import React from 'react';
import {
  PlayCircleOutlined,
  UserOutlined,
  ThunderboltOutlined,
  SafetyCertificateOutlined,
  ExperimentOutlined,
  FunnelPlotOutlined,
  BranchesOutlined,
  FlagOutlined,
  CheckCircleOutlined,
  DatabaseOutlined,
  BarChartOutlined,
} from '@ant-design/icons';
import { StepType, ProtocolConditionCategory } from '../../../../../types/lab/ProtocolTypes';

/** Single canonical icon map for all protocol step types. */
export const PROTOCOL_STEP_ICONS: Record<StepType, React.ReactNode> = {
  start:       <PlayCircleOutlined />,
  manual:      <UserOutlined />,
  automated:   <ThunderboltOutlined />,
  qc:          <SafetyCertificateOutlined />,
  results:     <ExperimentOutlined />,
  aliquot:     <FunnelPlotOutlined />,
  conditional: <BranchesOutlined />,
  end:         <FlagOutlined />,
};

/** Coloured icon for each condition category used in the condition editor. */
export const CONDITION_CATEGORY_ICONS: Record<ProtocolConditionCategory, React.ReactNode> = {
  step_outcome:  <CheckCircleOutlined style={{ color: '#10b981' }} />,
  field_value:   <DatabaseOutlined style={{ color: '#3b82f6' }} />,
  qc_result:     <SafetyCertificateOutlined style={{ color: '#f59e0b' }} />,
  sample_data:   <ExperimentOutlined style={{ color: '#8b5cf6' }} />,
  results_data:  <BarChartOutlined style={{ color: '#ec4899' }} />,
};
